export default __webpack_public_path__ + "static/mande-0405533913978ae2fbc84c61da555e71.svg";